




    import Vue from 'vue'
import { Component,Prop } from 'vue-property-decorator'
@Component
    export default class IconComponent extends Vue{
        @Prop()
        name:string

    }
